import { forwardRef } from 'react'

import { system, PropsOf } from '../../../system'
import { Input } from '../Input'
import { ChevronDownIcon } from '../../icons'

const NativeSelectInput = system('select')()

export const NativeSelect = forwardRef<
  HTMLSelectElement,
  PropsOf<typeof Input>
>(({ type = 'text', ...other }, ref) => (
  <Input
    ref={ref}
    type={type}
    as={NativeSelectInput}
    rightAddon={<ChevronDownIcon size='small' />}
    {...other}
  />
))
